<template>
    <div>
        <div class="vm-header-seize"></div>
        <div class="vm-header" id="vmHeader">
            <div class="vm-container" ref="header">
                <div class="vm-nav">
                    <div class="flex-between vm-out-box">
                        <div class="vm-nav-menu-list flex-start">
                            <a :href="(httpName)+'://www.'+(domainName)+'/'"><img :src="require('@/common/images/header/new_logo1.png')" alt="" class="vm-img-logo"></a>
                            <div class="vm-nav-menu-item tc-new-black pointer hover">
                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/?token='+ (user && user.loginToken ? user.loginToken : '')"><div class="vm-nav-menu-item-1">首页</div></a>
                                <div class="vm-line"></div>
                            </div>
                            <div class="vm-nav-menu-item tc-new-black pointer hover">
                                <a target="_blank" :href="(httpName)+'://ke.'+(domainName)+'/?token='+ (user && user.loginToken ? user.loginToken : '')"><div class="vm-nav-menu-item-1">课程</div></a>
                                <div class="vm-line"></div>
                            </div>
                            <div class="vm-nav-menu-item tc-new-black pointer hover">
                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/?token='+ (user && user.loginToken ? user.loginToken : '')"><div class="vm-nav-menu-item-1">资讯</div></a>
                                <div class="vm-line"></div>
                                <div class="vm-nav-menu-down-item vm-zx-menu-down-item box-shadow nowrap">
                                    <div class="vm-all-nav-menu-item-box flex-start">
                                        <span class="vm-all-nav-menu-item-title tc-new-black">鲸选</span>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/recom'" class="vm-all-nav-menu-item-2 hover tc-new-grey">鲸选</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/cycx'" class="vm-all-nav-menu-item-2 hover tc-new-grey">产业</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/sygl'" class="vm-all-nav-menu-item-2 hover tc-new-grey">智库</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/pevc'" class="vm-all-nav-menu-item-2 hover tc-new-grey">PE/VC</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/ss'" class="vm-all-nav-menu-item-2 hover tc-new-grey">解码IPO</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/bgcz'" class="vm-all-nav-menu-item-2 hover tc-new-grey">投融资</a>

                                    </div>
                                    <div class="vm-all-nav-menu-item-box flex-start">
                                        <span class="vm-all-nav-menu-item-title tc-new-black">资讯</span>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/gdxw'" class="vm-all-nav-menu-item-2 hover tc-new-grey">滚动新闻</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/hyqs'" class="vm-all-nav-menu-item-2 hover tc-new-grey">行业趋势</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/rwdh'" class="vm-all-nav-menu-item-2 hover tc-new-grey">人物对话</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/hdbd'" class="vm-all-nav-menu-item-2 hover tc-new-grey">活动报道</a>
                                    </div>
                                    <div class="vm-all-nav-menu-item-box flex-start">
                                        <span class="vm-all-nav-menu-item-title tc-new-black">事件</span>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/sssj'" class="vm-all-nav-menu-item-2 hover tc-new-grey">上市事件</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/rzsj'" class="vm-all-nav-menu-item-2 hover tc-new-grey">融资事件</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/bgsj'" class="vm-all-nav-menu-item-2 hover tc-new-grey">并购事件</a>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/mzsj'" class="vm-all-nav-menu-item-2 hover tc-new-grey">募资事件</a>
                                    </div>
                                    <div class="vm-all-nav-menu-item-box flex-start">
                                        <span class="vm-all-nav-menu-item-title tc-new-black">专栏</span>
                                        <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/author/lst.html'" class="vm-all-nav-menu-item-2 hover tc-new-grey">大咖专栏</a>
                                    </div>
                                </div>
                            </div>
                            <div class="vm-nav-menu-item tc-new-black pointer hover">
                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/telegraph?token='+ (user && user.loginToken ? user.loginToken : '')"><div class="vm-nav-menu-item-1">快讯</div></a>
                                <div class="vm-line"></div>
                            </div>
                            <div class="vm-nav-menu-item tc-new-black pointer hover" :class="{'vm-selected': selectIndex === 2}">
                                <div class="vm-nav-menu-item-1">知识服务</div>
                                <div class="vm-line"></div>
                                <div class="vm-nav-menu-down-item box-shadow">
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://ke.'+(domainName)+'/'">在线课堂</a>
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://live.'+(domainName)+'/'">精品直播</a>
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://report.'+(domainName)+'/'">精品投研</a>
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://ke.'+(domainName)+'/jjcy'">基金从业</a>
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://edu.'+(domainName)+'/'">商学院</a>
                                </div>
                            </div>
                            <div class="vm-nav-menu-item tc-new-black pointer hover" :class="{'vm-selected': selectIndex === 3}">
                                <div class="vm-nav-menu-item-1">企业服务</div>
                                <div class="vm-line"></div>
                                <div class="vm-nav-menu-down-item box-shadow">
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://hr.'+(domainName)+'/'">人才猎聘</a>
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://parks.'+(domainName)+'/'">政府园区</a>
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://czadmin.'+(domainName)+'/cms/articleTG/articleTGList?token='+ (user && user.loginToken ? user.loginToken : '')">我要投稿</a>
                                </div>
                            </div>
								<div class="vm-nav-menu-item tc-new-black pointer hover" :class="{'vm-selected': selectIndex === 4}">
                                <div class="vm-nav-menu-item-1">商业活动</div>
                                <div class="vm-line"></div>
                                <div class="vm-nav-menu-down-item box-shadow">
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://hd.'+(domainName)+'/'">行业峰会</a>
                                </div>
                            </div>
                            <div class="vm-nav-menu-item tc-new-black pointer hover">
                                <div class="vm-nav-menu-item-1">媒体服务</div>
                                <div class="vm-line"></div>
                                <div class="vm-nav-menu-down-item box-shadow">
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://www.'+(domainName)+'/index/swhz.html?token='+ (user && user.loginToken ? user.loginToken : '')">寻求报道</a>
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://www.'+(domainName)+'/index/swhz.html?token='+ (user && user.loginToken ? user.loginToken : '')">寻求融资</a>
                                    <a target="_blank" class="vm-nav-menu-item-2 tc-center tc-new-black hover" :href="(httpName)+'://czadmin.'+(domainName)+'/index?token='+ (user && user.loginToken ? user.loginToken : '')">我要入驻</a>
                                </div>
                            </div>
                            <div class="vm-all-nav flex-center">
                                <div class="vm-icon pointer">&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                <div class="vm-line"></div>
                                <div class="vm-all-nav-menu tc-new-grey">
                                    <div class="vm-out-box">
                                        <div v-if="!isZJ178Domain" class="vm-all-nav-menu-item">
                                            <div class="vm-all-nav-menu-item-1 tc-all-new-black">资讯</div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <span class="vm-all-nav-menu-item-title tc-new-black">鲸选</span>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/recom'" class="vm-all-nav-menu-item-2 hover tc-new-grey">鲸选</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/cycx'" class="vm-all-nav-menu-item-2 hover tc-new-grey">产业</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/sygl'" class="vm-all-nav-menu-item-2 hover tc-new-grey">智库</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/pevc'" class="vm-all-nav-menu-item-2 hover tc-new-grey">PE/VC</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/ss'" class="vm-all-nav-menu-item-2 hover tc-new-grey">解码IPO</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/bgcz'" class="vm-all-nav-menu-item-2 hover tc-new-grey">投融资</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <span class="vm-all-nav-menu-item-title tc-new-black">资讯</span>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/gdxw'" class="vm-all-nav-menu-item-2 hover tc-new-grey">滚动新闻</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/hyqs'" class="vm-all-nav-menu-item-2 hover tc-new-grey">行业趋势</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/rwdh'" class="vm-all-nav-menu-item-2 hover tc-new-grey">人物对话</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/hdbd'" class="vm-all-nav-menu-item-2 hover tc-new-grey">活动报道</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <span class="vm-all-nav-menu-item-title tc-new-black">事件</span>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/sssj'" class="vm-all-nav-menu-item-2 hover tc-new-grey">上市事件</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/rzsj'" class="vm-all-nav-menu-item-2 hover tc-new-grey">融资事件</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/bgsj'" class="vm-all-nav-menu-item-2 hover tc-new-grey">并购事件</a>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/mzsj'" class="vm-all-nav-menu-item-2 hover tc-new-grey">募资事件</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <span class="vm-all-nav-menu-item-title tc-new-black">专栏</span>
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/author/lst.html'" class="vm-all-nav-menu-item-2 hover tc-new-grey">大咖专栏</a>
                                            </div>
                                        </div>
                                        <div v-if="!isZJ178Domain" class="vm-all-nav-menu-item">
                                            <div class="vm-all-nav-menu-item-1 tc-all-new-black">快讯</div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/telegraph?token='+ (user && user.loginToken ? user.loginToken : '')" class="vm-all-nav-menu-item-2 hover tc-new-gray">7×24h快讯</a>
                                            </div>
                                        </div>
                                        <div class="vm-all-nav-menu-item">
                                            <div class="vm-all-nav-menu-item-1 tc-all-new-black">知识服务</div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://ke.'+(domainName)+''" class="vm-all-nav-menu-item-2 hover tc-new-gray">在线课堂</a>
                                            </div>
                                            <div v-if="!isZJ178Domain" class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://live.'+(domainName)+'/'" class="vm-all-nav-menu-item-2 hover tc-new-gray">精品直播</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://report.'+(domainName)+''" class="vm-all-nav-menu-item-2 hover tc-new-gray">精品投研</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://ke.'+(domainName)+'/jjcy'" class="vm-all-nav-menu-item-2 hover tc-new-gray">基金从业</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://edu.'+(domainName)+''" class="vm-all-nav-menu-item-2 hover tc-new-gray">商学院</a>
                                            </div>
                                        </div>
                                        <div class="vm-all-nav-menu-item">
                                            <div class="vm-all-nav-menu-item-1 tc-all-new-black">企业服务</div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://hr.'+(domainName)+''" class="vm-all-nav-menu-item-2 hover tc-new-gray">人才猎聘</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://parks.'+(domainName)+''" class="vm-all-nav-menu-item-2 hover tc-new-gray">政府园区</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://czadmin.'+(domainName)+'/cms/articleTG/articleTGList?token='+ (user && user.loginToken ? user.loginToken : '')" class="vm-all-nav-menu-item-2 hover tc-new-gray">我要投稿</a>
                                            </div>
                                        </div>
                                        <div class="vm-all-nav-menu-item">
                                            <div class="vm-all-nav-menu-item-1 tc-all-new-black">商业活动</div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://hd.'+(domainName)+''" class="vm-all-nav-menu-item-2 hover tc-new-gray">行业峰会</a>
                                            </div>
                                        </div>
                                        <div class="vm-all-nav-menu-item">
                                            <div class="vm-all-nav-menu-item-1 tc-all-new-black">媒体服务</div>
                                            <div v-if="!isZJ178Domain" class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/index/swhz.html?token='+ (user && user.loginToken ? user.loginToken : '')" class="vm-all-nav-menu-item-2 hover tc-new-gray">寻求报道</a>
                                            </div>
                                            <div v-if="!isZJ178Domain" class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/index/swhz.html?token='+ (user && user.loginToken ? user.loginToken : '')" class="vm-all-nav-menu-item-2 hover tc-new-gray">寻求融资</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://czadmin.'+(domainName)+'/index?token='+ (user && user.loginToken ? user.loginToken : '')" class="vm-all-nav-menu-item-2 hover tc-new-gray">我要入驻</a>
                                            </div>
                                        </div>
                                        <div class="vm-all-nav-menu-item">
                                            <div class="vm-all-nav-menu-item-1 tc-all-new-black">旗下产品</div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://gj.'+(domainName)+'/gjindex?token='+ (user && user.loginToken ? user.loginToken : '')" class="vm-all-nav-menu-item-2 hover tc-new-gray">股鲸</a>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <div class="vm-all-nav-menu-item-2 hover tc-new-gray pointer" @click="handleOpenSign360">签到360</div>
                                            </div>
                                            <div class="vm-all-nav-menu-item-box flex-start">
                                                <div class="vm-all-nav-menu-item-2 hover tc-new-gray pointer" @click="handleOpenReport">报告小程序</div>
                                            </div>
                                            <div v-if="!isZJ178Domain" class="vm-all-nav-menu-item-box flex-start">
                                                <a target="_blank" :href="(httpName)+'://www.'+(domainName)+'/index/matrix.html?token='+ (user && user.loginToken ? user.loginToken : '')" class="vm-all-nav-menu-item-2 hover tc-new-gray">公众号矩阵</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vm-header-search flex-end">
                            <el-dropdown>
                            <el-button type="primary" plain> {{searchType}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(obj,index) in typeList" :key="index" @click.native="handleDropSelect(obj.name)">{{obj.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                            </el-dropdown>
                            <el-input placeholder="搜索关键词" v-model="param.key"></el-input>
                            <el-button icon="el-icon-search" @click="search"></el-button>
                            <div class="vm-btns vm-dropdown flex-center app-dropdown">
                                <img class="appIcon" :src="require('@/common/images/header/app.png')" alt="">
                                <div class="vm-dropdown-menu">
                                    <img class="appCode" :src="require('@/common/images/header/app_code.png')" alt="">
                                    <p class="tips">扫码下载APP</p>
                                </div>
                            </div>
                            <div class="vm-btns tc-new-gray" v-if="!user.loginToken">
                                <img :src="require('@/common/images/header/user_icon.png')" alt="" @click="loginBtn" class="vm-logourl pointer">
                            </div>
                            <div class="vm-btns vm-dropdown flex-center" v-else>
                                <img :src="user.logourl" alt="" class="vm-logourl pointer">
                                <ul class="vm-dropdown-menu tc-new-gray">
                                    <li class="vm-dropdown-menu-title tc-center">{{user.nickname}}</li>							
                                    <li class="vm-dropdown-menu-1 tc-center"><a :href="(httpName)+'://my.'+(domainName)+'/personalCenter/ClassScheduleCard?token='+ user.loginToken" class="tc-new-gray hover">用户中心</a></li>
                                    <li class="vm-dropdown-menu-1 tc-center pointer" @click="exitLogin">退出登录</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog title="" :visible.sync="sign360Visible" width="234px" center class="vm-qrcode-dialog">
                <div class="content flex-center">
                    <img v-lazy="'http://img.capwhale.com/mpcode_sign360.jpg'" alt="" class="img">
                    <div class="tip">微信扫一扫体验小程序</div>
                </div>
            </el-dialog>
            <el-dialog title="" :visible.sync="reportVisible" width="234px" center class="vm-qrcode-dialog">
                <div class="content flex-center">
                    <img v-lazy="'http://img.capwhale.com/mpcode_report.jpg'" alt="" class="img">
                    <div class="tip">微信扫一扫体验小程序</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import types from './../../views/reportPc/reportindex/components/type.json' // 分类
export default {
    name: 'ReportHeader',
    data() {
        return {
            searchType: '全部',
			typeList: [
                {code: '', name: '全部'},
                {code: 1, name: '报告'},
                {code: 2, name: '课程'},
                {code: 3, name: '题库'},
                {code: 4, name: '直播'},
                {code: 5, name: '活动'}
			],
			param: {
                code: '',
                key: ''
			},
			sign360Visible: false,
            reportVisible: false,
            reportSearchData: '',
            isZJ178Domain:false,//是否是资鲸178域名，需要屏蔽直播和资讯
            domainName:'capwhale.com',
            httpName:"https",
            selectIndex: 0,
            kmdomainList: [
                'ke.capwhale.com',
                'ke.zj178.com',
                'live.capwhale.com',
                'live.zj178.com',
                'report.capwhale.com',
                'report.zj178.com',
                'edu.capwhale.com',
                'edu.zj178.com',
            ],
            entdomainList: [
                'hr.capwhale.com',
                'hr.zj178.com',
                'parks.capwhale.com',
                'parks.zj178.com',
            ],
            hddomainList: [
                'hd.capwhale.com',
                'hd.zj178.com',
            ],
            first: true,
            scrollTop: 0
        }
    },
    mounted() {
        this.reportSearchData = types
        if (this.kmdomainList.indexOf(location.hostname) > -1) {
            this.selectIndex = 2
        } else if (this.entdomainList.indexOf(location.hostname) > -1) {
            this.selectIndex = 3
        } else if (this.hddomainList.indexOf(location.hostname) > -1) {
            this.selectIndex = 4
        }
        if(location.hostname.indexOf("zj178.com")>=0){
            this.isZJ178Domain=true
            this.domainName='zj178.com'
            this.httpName="http"
        }
        // console.log('this.user',this.user)

        const header = this.$refs.header
        const that = this
        document.body.onscroll = function(e) {
            // console.log(this.first)
            if (that.first) {
                that.scrollTop = e.srcElement.scrollingElement.scrollTop
                that.first = false
            } else {
                if (e.srcElement.scrollingElement.scrollTop < that.scrollTop) { // 往上滚动 显示导航栏
                    header.classList.remove('hide')
                } else { // 往下滚动 收起导航栏
                    header.classList.add('hide')
                }
                that.scrollTop = e.srcElement.scrollingElement.scrollTop
            }
        }
    },
    methods: {
        //跳转首页
        gotoPageMain(){
            if(this.isZJ178Domain){
                location.href="http://www."+this.domainName
            }
            else{
                location.href="https://www."+this.domainName
            }
        },
        // 媒体矩阵
        toMediaMatrix() {
            this.$router.push({name: 'MediaMatrix2'})
        },
        toPageFn() {
            window.open(`${this.domainlist.url_gj}/gjindex`)
        },
        clickcourse() {
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_course}/pindex?token=${this.user.loginToken}`)
            } else {
                window.open(`${this.domainlist.url_course}/pindex`)
            }
        },
        clickReport() {
            // this.$router.push({name: 'ReportIndex'})
            if (this.user.loginToken) {
                window.location.href=`${this.domainlist.url_report}/reportindex?token=${this.user.loginToken}`
            } else {
                window.location.href=`${this.domainlist.url_report}/reportindex`
            }
        },
        // 登录、注册弹窗
        loginBtn() {
            this.setLoginPop(true)
        },
        // 搜索框前面选择搜索内型
        handleDropSelect (val) {
            this.searchType = val
        },
        // 点击报告下单个分类
        reportClassClick(val) {
            // this.$router.push({name: 'ReportSearch',query: {catecode: val}})
            if (this.user.loginToken) {
                window.location.href=`${this.domainlist.url_report}/reportsearch?catecode=${val}&token=${this.user.loginToken}`
            } else {
                window.location.href=`${this.domainlist.url_report}/reportsearch?catecode=${val}`
            }
        },
        search() {  // 搜索课程
            let domain = 1
            if(window.location.hostname.indexOf('ke.capwhale.com')>=0 || window.location.hostname.indexOf('ke.zj178.com')>=0){
                domain = 1
            } else {
                domain = 2
            }
            // console.log(this.searchType)
            switch(this.searchType) {
                case '全部':
                    this.$router.push({name: 'AllSearch',query: {data: this.param.key}})
                    break;
                case '报告':
                    this.$router.push({name: 'ReportSearch',query: {data: this.param.key}})
                    break;
                case '课程':
                    if (domain === 1) {
                        this.$router.push({name: 'Search',query: {data: this.param.key, searchtype: '1'}})
                    } else {
                        // location.href = `${this.domainlist.url_course}/search?data=${this.searchData}&searchtype=1`
                        window.open(`${this.domainlist.url_course}/search?data=${this.param.key}&token=${this.user.loginToken}`)
                    }
                    break;
                case '题库':
                    if (domain === 1) {
                        this.$router.push({name: 'Search',query: {data: this.param.key, searchtype: '2'}})
                    } else {
                        // location.href = `${this.domainlist.url_course}/search?data=${this.searchData}&searchtype=2`
                        window.open(`${this.domainlist.url_course}/QuestionSearch?data=${this.param.key}&token=${this.user.loginToken}`)
                    }
                    break;
                case '直播':
                    // if (domain === 1) {
                        this.$router.push({name: 'LiveingSearch',query: {data: this.param.key}})
                    // } else {
                        // location.href = `${this.domainlist.url_course}/search?data=${this.searchData}&searchtype=2`
                        // window.open(`${this.domainlist.url_course}/LiveingSearch?data=${this.searchData}&token=${this.user.loginToken}`)
                    // }
                    break;
                case '活动':
                    this.$router.push({name: 'HdSearch',query: {data: this.param.key}})
                    break;
            }
            // if (this.searchData.length > 0) {
            //     this.$router.push({name: 'ReportSearch',query: {data: this.searchData}})
            // } else {
            //     this.$router.push({name: 'ReportSearch'})
            // }
        },
        // 退出登录
        exitLogin() {
            window.sessionStorage.clear()
            let user = {
                innerid: '',
                loginToken: '',
                loginname: '',
                logourl: '',
                mobile: '',
                name: '',
                nickname: '',
                isLogin: false
            }
            this.setUser(user)
            this._delCookie('token')
            this.$message.success('退出成功！')
        },
        _setCookie(key, value, expiredays) {
            let exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie = key + '=' + value
            + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
            + ';path=/'
            + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
        },
        _delCookie(key) {
            this._setCookie(key, "", -1);
        },
        // 前往个人中心页面
        gotoRouterPersonalCenter(val) {
            // this.$router.push({name: val})
            if (this.user.loginToken) {
                // window.open(`${this.domainlist.url_course}/pindex?token=${this.user.loginToken}`)
                window.location.replace(`${this.domainlist.url_my}/personalCenter/${val}?token=${this.user.loginToken}`)
            } else {
                // window.open(`${this.domainlist.url_course}/pindex`)
                window.location.replace(`${this.domainlist.url_my}/personalCenter/${val}`)
            }
        },
        // 上传点击跳转到https://admin.jkt.capwhale.com/login
        uploadingClick() {
            window.open('${this.domainlist.url_czadmin}/creativeCenter?token=' + this.user.loginToken, '_blank')
        },
        goToTest() {
            this.$router.push({
                name: 'Jjcy'
            })
        },
        handleOpenSign360() {
			this.sign360Visible = true
		},
		handleOpenReport() {
			this.reportVisible = true
		},
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    watch: {},
    filters: {},
    computed: {
        ...mapGetters(
            ['user', 'domainlist','domainInfo']
        )
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.tc-new-black{color: #666 !important;}
.tc-all-new-black{color: #333 !important;}
.tc-new-gray{color: #666 !important;}
.tc-new-grey{color: #999 !important;}
.tc-lightgrey{color: #FAFAFA !important;}
.tc-write{color: #fff !important;}
.tc-blue{color:  #409EFF !important;}
.tc-red{color: #E13B29 !important;}
.tc-center{text-align: center !important;}
.tc-blod{font-weight: 600;}
.pointer{cursor: pointer;}
.nowrap{white-space: nowrap;}

.hover:hover{color: #409EFF !important;}
	
.flex-start{display: flex;align-items: center;}
.flex-between{display: flex;align-items: center;justify-content: space-between;}
.flex-end{display: flex;align-items: center;justify-content: flex-end;}
.flex-center{display: flex;align-items: center;justify-content: center;}

.box-shadow{box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)}
.vm-header-seize{
		height: 60px;
    }
	.vm-header .vm-container{
		font-size: 14px;
		position: fixed;
		top:0;
		left: 0;
		right: 0;
		height: 60px;
		z-index: 11;
        min-width: 1200px;
        transition: all 0.3s;
    }
    .vm-header .vm-container.hide {
        top: -60px;
    }
	.vm-header .vm-out-box{
		width: 1200px;
		margin: auto;
	}
	.vm-header .vm-nav{
		display: flex;
		align-items: center;
		height: 60px;
		color: #333;
		background: #fff;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
	}
	.vm-header .vm-nav a{
		display: block;
	}
	.vm-header a:hover{
		color: #1464C8;
	}
	.vm-header .vm-img-logo{
		width: 80px;
		height: 22px;
		margin-right: 30px;
	}
	.vm-header .vm-nav-menu-item{
		padding: 4px 15px 0;
		font-size: 16px;
		height: 60px;
		position: relative;
		display: flex !important;
		justify-content: center;
		align-items: center;
        flex-direction: column;
        box-sizing: border-box;
	}
	.vm-header .vm-nav-menu-item .vm-nav-menu-down-item{
		font-size: 14px;
		display: none;
		opacity: 0;
		position: absolute;
		line-height: normal;
		transition: all .5s;
		background: #fff;
		width: 130px;
		padding: 6px 0;
		left:calc(50% - 65px);
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
		z-index: -1;
	}
	.vm-header .vm-nav-menu-item .vm-nav-menu-item-1{
		padding-bottom: 5px;
        color: #333;
        // font-weight: 450;
	}
	.vm-header .vm-selected.vm-nav-menu-item .vm-nav-menu-item-1{
		color: #1464C8;
	}
	.vm-header .vm-nav-menu-item:hover .vm-nav-menu-item-1{
		color: #1464C8;
	}
	.vm-header .vm-line{
		height: 0;
		width: 0;
		background: transparent;
		border-radius: 1.5px;
		transition: all .3s;
		border: 1.5px solid transparent;
        box-sizing: border-box;
	}
	.vm-header .vm-selected .vm-line, .vm-header .vm-nav-menu-item:hover .vm-line{
		background: #1464C8;
		border-color: #1464C8;
		width: 30px;
	}
	.vm-header .vm-all-nav{
		flex-direction: column;
		height: 60px;
	}
	.vm-header .vm-all-nav .vm-icon{
		background: url('../../common/images/header/all_ash.svg') no-repeat center;
		width: 16px;
		height: 16px;
		padding: 0 20px;
        margin-bottom: 5px;
        // margin-top: 5px;
        position: relative;
        top: 3px;
}
	.vm-header .vm-all-nav:hover .vm-icon{
		background: url('../../common/images/header/all_blue.svg') no-repeat center center;
	}
	.vm-header .vm-nav-menu-down-item .vm-nav-menu-item-2{
		height: 36px;
		line-height: 36px;
	}
	.vm-header .vm-nav-menu-down-item .vm-nav-menu-item-2:hover{
		background: #F8F8F8;
	}
	.vm-header .vm-nav-menu-item:hover .vm-nav-menu-down-item{
		display: block;
		transition: all 1s;
		animation: downitem .5s infinite;
		animation-iteration-count: 1;
		animation-fill-mode : forwards;
	}
	@keyframes downitem {
		0% {
			top: 0;
		}
		100% {
			top: 60px;
			opacity: 1;
		}
	}
	.vm-header .vm-header-search .el-button--primary.is-plain{
		width: 60px;
		height: 30px;
		border-radius: 15px 0 0 15px;
		padding: 0;
		font-size: 12px;
		border-width: 0;
	}
	.vm-header .vm-header-search .el-input,.vm-header .vm-header-search input{
		height: 30px;
		border-width: 0;
		background: #F8F8F8;
		width: 120px;
		font-size: 12px;
		font-weight: 200;
	}
	.vm-header .vm-header-search .el-button--default{
		border-radius: 0 15px 15px 0;
		background: #F8F8F8;
		width: 40px;
		height: 30px;
		border-width: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0;
		margin: 0;
		color: #CCCCCC;
	}
	.vm-header .vm-header-search .el-button--default:hover{
		color: #409EFF;
	}
	.vm-header .vm-header-search .el-input__icon{
		line-height: 30px;
	}
	.vm-header .vm-header-search .vm-btns{
		margin-left: 30px;
	}
    .vm-header .appIcon {
        width: 26px;
        height: 26px;
    }
	.vm-header .vm-logourl{
		width: 34px;
		height: 34px;
		border-radius: 50%;
	}
    .vm-header .appCode {
        width: 140px;
        height: 140px;
        margin: auto;
    }
    .app-dropdown .vm-dropdown-menu {
        width: 150px !important;
        padding: 15px 0 !important;
    }
    .app-dropdown .vm-dropdown-menu .tips {
        text-align: center;
        margin-top: 5px;
    }
	.vm-header .dropdown-menu{
		top: 50px;
		border-width: 0;
		min-width: auto;
	}
	.vm-header .dropdown-menu>li>a{
		color: #666;
	}
	.vm-header .dropdown-menu>li>a:hover{
		background: #F2F6FC;
		color: #409EFF;
	}
	.vm-header .divider{
		margin: 4px 0;
	}
	.vm-header .vm-nav .hover:hover{
		color: #1464C8 !important;
	}
	.vm-header .vm-all-nav-menu{
		position: absolute;
		background: #fff;
		top: 60px;
		left: 0;
		right: 0;
		font-size: 16px;
		display: none;
		z-index: -1;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
		background: url('../../common/images/header/bg.jpg') no-repeat;
		background-size: 100% 100%;
	}
	.vm-header .vm-all-nav-menu-item{
		padding: 30px 0;
		margin-right: 40px;
	}
	.vm-header .vm-all-nav-menu-item-box{
		font-size: 14px;
		margin-top: 8px;
	}
	.vm-header .vm-all-nav-menu-item-title{
		margin-right: 20px;
		line-height: 20px;
        height: 20px;
        cursor: auto;
	}
	.vm-header .vm-all-nav-menu-item-1{
		padding-bottom: 7px;
	}
	.vm-header .vm-all-nav-menu-item-2{
		margin-right: 20px;
		line-height: 20px;
		height: 20px;
	}
	.vm-header .vm-all-nav-menu .vm-out-box{
		display: flex;
	}
	.vm-all-nav:hover .vm-all-nav-menu{
		display: block;
		transition: all 1s;
		animation: downallitem .5s infinite;
		animation-iteration-count: 1;
		animation-fill-mode : forwards;
	}
	@keyframes downallitem {
		0% {
			top: 40px;
			opacity: 0;
		}
		100% {
			top: 60px;
			opacity: 1;
		}
	}
	.vm-header .vm-dropdown{
		position: relative;
		height: 60px;
	}
	.vm-header .vm-dropdown .vm-dropdown-menu{
		padding: 6px 0;
		opacity: 0;
		display: none;
		position: absolute;
		width: 130px;
		right: -50px;
		background: #FFFFFF;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
		z-index: -1;
	}
	// @media screen and (max-width: 1300px) {
	//     .vm-header .vm-dropdown .vm-dropdown-menu {
	//         right: 0;
	//     }
	// }
	.vm-header .vm-dropdown:hover .vm-dropdown-menu{
		display: block;
		transition: all 1s;
		animation: downitem .5s infinite;
		animation-iteration-count: 1;
		animation-fill-mode : forwards;
	}
	.vm-header .vm-dropdown .vm-dropdown-menu li{
		height: 36px;
		line-height: 36px;
	}
	.vm-header .vm-dropdown .vm-dropdown-menu .vm-dropdown-menu-1:hover{
		background:  #F8F8F8;
		color: #1464C8;
	}
	.vm-header .vm-dropdown .vm-dropdown-menu .vm-dropdown-menu-title{
		border-bottom: 1px solid #F5F5F5;
	}
	.vm-header .vm-zx-menu-down-item{
		width: auto !important;
		left: -25px !important;
		padding: 5px 50px 20px 50px !important;
	}
	
	.vm-header .vm-qrcode-dialog .content {
		flex-direction: column;
		height: 180px;
	}
	
	.vm-header .vm-qrcode-dialog .img {
		width: 143px;
		height: 143px;
		margin-bottom: 15px;
	}
	
	.vm-header .vm-qrcode-dialog .tip {
		font-size: 16px;
		line-height: 22px;
	}
	
	.vm-header .vm-qrcode-dialog .tip+.tip {
		margin-top: 8px;
	}
	.vm-header .vm-qrcode-dialog .el-dialog__headerbtn{
		top: 10px;
		right: 10px;
	}
	.vm-header .vm-qrcode-dialog .el-dialog__body{
		padding: 0 0 30px 0;
	}
</style>